export default __webpack_public_path__ + "static/media/account-bg-new.0c0a50c5.png";